import { render, staticRenderFns } from "./MapCanvas.vue?vue&type=template&id=3e6c7fd4&scoped=true"
import script from "./MapCanvas.vue?vue&type=script&lang=js"
export * from "./MapCanvas.vue?vue&type=script&lang=js"
import style0 from "./MapCanvas.vue?vue&type=style&index=0&id=3e6c7fd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c7fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6c7fd4')) {
      api.createRecord('3e6c7fd4', component.options)
    } else {
      api.reload('3e6c7fd4', component.options)
    }
    module.hot.accept("./MapCanvas.vue?vue&type=template&id=3e6c7fd4&scoped=true", function () {
      api.rerender('3e6c7fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MapCanvas.vue"
export default component.exports